import React, { useState, useEffect } from 'react';
import Header from "../../common/Header/index"
import AboutUs from "../../common/AboutUs/index"
import Catalogue from "../../common/Catalogue/index"
import Benefits from "../../common/Benefits/index"
import Sustainability from "../../common/Sustainability/index"
import Faq from "../../common/Faq/index"
import NewFooter from "../../common/NewFooter"
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { publicAPI } from "../../utils/api";
import { toast } from "react-toastify";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [allGroups, setAllGroups] = useState([]);

  const getAllGroups = async () => {
    setLoading(true);

    try {
      const response = await publicAPI.get(`/public/bacchus/productgroup`);
      setAllGroups(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getAllGroups();
  }, []);

  return (
      <React.Fragment>
        <Header/>
        <AboutUs
          allGroups={allGroups}
          />
        <Catalogue/>
        <Benefits/>
        <Sustainability/>
        <Faq/>
        <NewFooter/>
        <Backdrop
          sx={{ color: '#fff', zIndex: 1000 }}
          open={loading}
          >
          <CircularProgress color="inherit" />
        </Backdrop>
      </React.Fragment>
  );
}

export default Home;
